const HIDE_COMPONENTS = []

export { HIDE_COMPONENTS }
